export enum SunlabsConnectorType {
  Normal = "Normal",
  Detachable = "Detachable",
  HingeForLidStay = "HingeForLidStay",
  Lock = "Lock",
}
